import { ENVIRONMENT_INITIALIZER, inject, Provider } from '@angular/core';
import {
    provideAiRequestContextContributor,
    providePromptResponseInterceptor,
    provideStreamingPromptResponseInterceptor
} from '@panaya/ai-chat/domain';
import { createCanvasFrameInterceptor } from './canvas-frame.interceptor';
import { createCanvasTurnEndInterceptor } from './canvas-turn-end.interceptor';
import { createCanvasRequestContextContributor } from './canvas-request-context.contributor';
import { CanvasResetService } from './canvas-reset.service';

/**
 * Everything a host adds to get canvas mode: the frame and end-of-turn interceptors, the `canvas` request-context
 * field and the reset when the thread changes. List it after the generic thinking interceptor so the canvas
 * status-line texts win. Tools are registered with `provideCanvasForTool`; displays with `provideCanvasDisplay`
 * or `provideCanvasDraft()` (`@panaya/ai-chat/canvas-draft`).
 */
export function provideCanvasFrame(): Provider[] {
    return [
        provideStreamingPromptResponseInterceptor(createCanvasFrameInterceptor),
        providePromptResponseInterceptor(createCanvasTurnEndInterceptor),
        provideAiRequestContextContributor(createCanvasRequestContextContributor),
        { provide: ENVIRONMENT_INITIALIZER, multi: true, useValue: () => inject(CanvasResetService) }
    ];
}
